import React from "react";
import usePageMeta from "../../utils/usePageMeta";
import Section2 from "../../components/Section2";
import ExperienceSection from "../../components/ExperienceSection";
import Section10 from "../../components/Section10";

const AboutPage = () => {
  usePageMeta({
    title: "About",
    description:
      "Hamza Mehboob, software consultant in Karachi, and the senior team behind the web, mobile and desktop products we ship for clients worldwide.",
    path: "/about",
  });
  return (
    <>
      <div className="py-10 md:py-16">
        <Section2 />
      </div>
      <ExperienceSection />
      <div className="mt-6">
        <Section10 />
      </div>
    </>
  );
};

export default AboutPage;
